import './oil_field_detail.css'
import * as echarts from 'echarts/core';
import { Form, Input, InputNumber, message} from 'antd';
import React, { useEffect, useState } from 'react';
import Request from '../../../request';
import { COLOR_LIST, COLOR_REVERSE_LIST } from '../../../config';



const App = (props: any) => {
  console.log('props=', props)

  const [statusMap, _] = useState({0: "未运行", 1: "运行中", 2: "异常"})

  let request = new Request({});
  const [data, setData] = useState<any>({});

  const [period, setPeriod] = useState("近三月")

  const fetchData = (id: string) => {
    request.get('/api/v1/admin/oilfields/' + id + '/').then((res: any)=>{
      if(res.code === 0){
        console.log('res=', res.data)
        setData(res.data)
      }
    })
  }

  const fetchReportData = (id: string) => {
    request.get('/api/v1/admin/report/record/?category=month&shortcut=' + period + '&oil_field_id=' + id).then((res: any)=>{
        
      var xAxisDataArray = []
        var seriesDataArray = []

        for(var i=0; i<res.data.length; i++){
          let  series = { 
            value: res.data[i].processed_oil, 
          }
          xAxisDataArray.push(res.data[i].date)
          seriesDataArray.push(series)
        }

        let myChart = echarts.init(document.getElementById('oil-field-detail-report-chart') as HTMLElement, {renderer: 'svg'}, {devicePixelRatio: 2.5})

        let option = {
          xAxis: {
            type: 'category',
            data: xAxisDataArray
          },
          yAxis: {
            type: 'value'
          },

          tooltip: {
            show: true
          },
          series: [
            {
              data: seriesDataArray,
              type: 'bar',
              barWidth: seriesDataArray.length < 20 ? 20 : 0,
            }
          ]
        };
          
        myChart.setOption(option)
      })
  }

  useEffect(()=>{
    fetchData(props.id)
    fetchReportData(props.id)
  }, [period])

  const choosePeriod = (e: any) => {
    console.log(e.target.dataset.period)
    setPeriod(e.target.dataset.period)
  }

  return (
    <div className="oil-field-detail-container">
      <div className="oil-field-detail-header">
        <div>ID:{data.id}</div>
        <div className="oil-field-detail-info-list">
          <div className="oil-field-detail-info-item">名称:{data.name}</div>
          <div className="oil-field-detail-info-item">油井数量:{data.oil_total_number}</div>
          <div className="oil-field-detail-info-item">省市区:{data.province}-{data.city}-{data.district}</div>
          <div className="oil-field-detail-info-item">详细地址:{data.area}</div>
          <div className="oil-field-detail-info-item">创建时间:{data.add_time}</div>
          <div className="oil-field-detail-info-item">状态:{statusMap[data.status]}</div>
        </div>
      </div>
      <div className="oil-field-detail-report">
        <div className="oil-field-detail-report-period">
          <div className="oil-field-detail-report-peroid-list">
            <div className={period === "近三月" ?"oil-field-detail-report-peroid-item oil-field-detail-report-period-item-right oil-field-detail-report-period-item-selected":"oil-field-detail-report-peroid-item oil-field-detail-report-period-item-right"} onClick={choosePeriod} data-period="近三月">近三月</div>
            <div className={period === "近半年" ?"oil-field-detail-report-peroid-item oil-field-detail-report-period-item-right oil-field-detail-report-period-item-selected":"oil-field-detail-report-peroid-item oil-field-detail-report-period-item-right"} onClick={choosePeriod} data-period="近半年">近半年</div>
            <div className={period === "近一年" ?"oil-field-detail-report-peroid-item oil-field-detail-report-period-item-selected":"oil-field-detail-report-peroid-item"} onClick={choosePeriod} data-period="近一年">近一年</div>
          </div>
        </div>
        <div id="oil-field-detail-report-chart"></div>
      </div>
    </div>
  );
};

export default App;